module.exports = __webpack_public_path__ + "static/media/pu_logo.d9474fff.jpeg";